module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray-2edeee953732c64cb3cf9a60d55a86a9.png";